import React from "react";
import { cn } from "../../lib/utils";

export default function Progress({ value = 0, className = "", indicatorClassName = "" }) {
  const normalized = Number.isFinite(Number(value)) ? Math.min(100, Math.max(0, Number(value))) : 0;

  return (
    <div
      className={cn("relative h-2 w-full overflow-hidden rounded-full bg-muted", className)}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(normalized)}
    >
      <div
        className={cn("h-full bg-action transition-all duration-300 ease-out", indicatorClassName)}
        style={{ width: `${normalized}%` }}
      />
    </div>
  );
}
